module.exports = __webpack_public_path__ + "static/img/exchange_vip_top.c54f77d8.png";